import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAlipayComponent } from './simple-icons-alipay.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAlipayComponent ],
    exports:      [ SimpleIconsAlipayComponent ],
    bootstrap:    []
})
export class SimpleIconsAlipayModule {}
